import React from "react";
import { useFrame } from "react-frame-component";

export interface Frame {
    document: Document;
    window: Window;
}

export interface WithFrameProps {
    iframe: Frame;
}

export default function withFrame<T extends WithFrameProps = WithFrameProps>(WrappedComponent: React.ComponentType<T>) {
    const ComponentWithFrame = (props: Omit<T, keyof WithFrameProps>) => {
        const iframe = useFrame();
        return <WrappedComponent iframe={iframe} {...(props as T)} />;
    };

    ComponentWithFrame.displayName = `withFrame(${
        WrappedComponent.displayName || WrappedComponent.name || "Component"
    })`;

    return ComponentWithFrame;
}
